// Stripe publishable test key
export const STRIPE_PUBLISHABLE_KEY = process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY

// create instance of Stripe object
export const stripe = window.Stripe(STRIPE_PUBLISHABLE_KEY)

// create instance of Elements (pre-built UI components) to collect payment info
const elements = stripe.elements()

// custom styling passed to options when creating an Element
const baseStyle = {
  base: {
    color: '#32325d',
    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
    fontSmoothing: 'antialiased',
    fontSize: '16px',
    '::placeholder': {
      color: '#aab7c4',
    },
  },
  invalid: {
    color: '#fa755a',
    iconColor: '#fa755a',
  },
}

// create instance of card element with styling
// export to be used in StripeForm.vue
export const stripeCard = elements.create('card', { style: baseStyle })
